import { render } from "./ClassManager.vue?vue&type=template&id=5fb3f413&scoped=true"
import script from "./ClassManager.vue?vue&type=script&lang=js"
export * from "./ClassManager.vue?vue&type=script&lang=js"

import "./ClassManager.vue?vue&type=style&index=0&id=5fb3f413&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb3f413"]])

export default __exports__